/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

// This is the main entrypoint file for webpack.
// The async import() below is used to bootstrap module federation.
// (https://webpack.js.org/concepts/module-federation/#troubleshooting)
// From the link:
//   We strongly recommend using an asynchronous boundary.
//   It will split out the initialization code of a larger chunk
//   to avoid any additional round trips and improve performance in general.

void import("~/setup/render");

// https://www.typescriptlang.org/tsconfig#isolatedModules
export {};
